<template>
    <div class="LifeskillNumberTag" :class="`size-${size}`" :data-theme="category">
        <div v-if="showLabel" class="label">
            {{ $t(`dashboard.general.categoryLabels.${category}`) }}
        </div>
        <div class="number" :class="{ 'is-darker': darken, 'use-shadow': useShadow }">
            <span v-if="lifeskill">{{ lifeskill.number }}</span>
            <span v-else style="visibility: hidden;">00</span>
        </div>
    </div>
</template>

<script>
import { getCategoryIdFromLifeskillId, getLifeskillRangeFromCategoryId } from '@/utils';

export default {
    name: 'LifeskillNumberTag',
    props: {
        categoryId: {
            type: String
        },
        lifeskillId: {
            type: String
        },
        showLabel: {
            type: Boolean
        },
        darken: {
            type: Boolean
        },
        useShadow: {
            type: Boolean
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['normal', 'large'].indexOf(value) !== -1;
            }
        }
    },
    computed: {
        category() {
            return this.categoryId || getCategoryIdFromLifeskillId(this.lifeskillId);
        },
        lifeskill() {
            return this.$store.getters['moduleApp/getLifeskillById'](this.lifeskillId);
        }
    }
};
</script>

<style lang="scss" scoped>
.LifeskillNumberTag {
    width: 35px;
    margin-bottom: 0;
    margin-left: 2px;
    transform: translate3d(
        0,
        0,
        0
    ); // Needed for safari bug https://stackoverflow.com/questions/5472802/css-z-index-lost-after-webkit-transform-translate3d
    @media (max-width: 774px) {
        margin-left: 0;
    }
    &.size-large {
        .number {
            font-size: 90%;
            padding: 0.3em 0.8em;
            font-weight: 600;
        }
    }
}

.label {
    color: rgba(white, 0.8);
    text-transform: uppercase;
    letter-spacing: 0.2em;
    font-weight: 300;
    margin-right: 0.5em;
    font-size: 90%;
}
.number {
    background-color: $standardButtonColor; //gba(red, 0.2);
    padding: 3px 7px;
    border-radius: 2em;
    color: rgba(white, 0.8);
    font-size: 10px;
    text-align: center;

    &.use-shadow {
        box-shadow: 0 0 0.5em rgba(black, 0.3);
    }
}

// ---------------------------
// Theming
// ---------------------------

@each $lifeAreaId, $color in $lifeAreaColors {
    .LifeskillNumberTag[data-theme='#{$lifeAreaId}'] {
        .number {
            background-color: $color;

            &.is-darker {
                background-color: darken($color, 10%);
            }
        }
    }
}
</style>
